import type { FC } from 'react';
import React from 'react';

import { Size } from '../types';
import WorkspaceAvatar from '../WorkspaceAvatar/WorkspaceAvatar';
import {
  ImageWrapper,
  UserAvatarImage,
  WorkspaceAvatarWrapper,
  Wrapper,
} from './UserAvatar.styled';

export interface UserAvatarProps {
  /**
   * Changes the size. It can be one of the following options: `UserAvatar.Size.XS`, `UserAvatar.Size.S`,
   *  `UserAvatar.Size.M`, `UserAvatar.Size.L`, `UserAvatar.Size.XL`, `UserAvatar.Size.XXL`, `UserAvatar.Size.XXXL`
   */
  size?: Size;
  /**
   * The URL of the image of the user avatar
   */
  src?: string;
  /**
   * The URL of the team avatar image (if we want to display the avatar of a team next to the avatar of a user)
   */
  teamAvatarSrc?: string;
  /**
   * Team name (if we want to display a team's avatar next to a user's avatar)
   */
  teamName?: string;
}

const getWorkspaceAvatarSize = (size: Size) => {
  switch (size) {
    case Size.XS:
    case Size.S:
    case Size.M:
    case Size.L:
      return WorkspaceAvatar.Size.XS;
    case Size.XL:
    case Size.XXL:
      return WorkspaceAvatar.Size.L;
    case Size.XXXL:
      return WorkspaceAvatar.Size.XL;
    default:
      return WorkspaceAvatar.Size.XS;
  }
};

const UserAvatar: FC<UserAvatarProps> & { Size: typeof Size } = ({
  size = Size.M,
  src,
  teamAvatarSrc,
  teamName,
}) => (
  <Wrapper>
    <ImageWrapper $size={size} $hasImage={!!src}>
      <UserAvatarImage $src={src} $size={size} />
    </ImageWrapper>
    {(teamName || teamAvatarSrc) && (
      <WorkspaceAvatarWrapper>
        <WorkspaceAvatar
          src={teamAvatarSrc}
          size={getWorkspaceAvatarSize(size)}
          name={teamName}
        />
      </WorkspaceAvatarWrapper>
    )}
  </Wrapper>
);

UserAvatar.Size = Size;

export default UserAvatar;
